export default function BrandLogo({
  className,
  title = 'DIZEE',
}: {
  className?: string
  title?: string
}) {
  return (
    <svg
      viewBox="0 0 5004 940"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      className={className}
    >
      <title>{title}</title>
      <path
        d="M749.012 461.008C749.012 615.509 707.082 733.582 623.224 815.294C539.365 897.006 418.676 937.862 261.224 937.862H2V2H288.796C434.307 2 547.416 42.3194 628.054 122.958C708.692 203.596 749.012 316.302 749.012 461.008ZM633.757 464.832C633.757 342.801 603.165 250.825 541.915 188.971C480.664 127.117 389.695 96.123 268.872 96.123H110.747V843.806H243.244C372.99 843.806 470.467 811.939 535.809 748.14C601.152 684.273 633.757 589.882 633.757 464.832Z"
        fill="currentColor"
      />
      <path d="M1363.4 937.862V2H1472.21V937.862H1363.4Z" fill="currentColor" />
      <path
        d="M2729.89 937.862H2086.6V852.728L2583.31 99.947H2101.96V2H2715.8V87.1332L2219.09 839.243H2729.89V937.862Z"
        fill="currentColor"
      />
      <path
        d="M3865.95 937.862H3344.28V2H3865.95V98.6723H3453.09V400.161H3840.99V496.161H3453.09V840.519H3865.95V937.862Z"
        fill="currentColor"
      />
      <path
        d="M5002 937.862H4480.33V2H5002V98.6723H4589.15V400.161H4977.04V496.161H4589.15V840.519H5002V937.862Z"
        fill="currentColor"
      />
    </svg>
  )
}

